module.exports = __webpack_public_path__ + "media/klaseaDia3K62Vert.58a9bf34.mp4";